export const reOrgStoreConstants = {
	Create: {
		FAILURE : 'CREATE_RE_ORG_STORE_FAILURE',
		REQUEST : 'CREATE_RE_ORG_STORE_REQUEST',
		SUCCESS : 'CREATE_RE_ORG_STORE_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_RE_ORG_STORE_FAILURE',
		REQUEST : 'DELETE_RE_ORG_STORE_REQUEST',
		SUCCESS : 'DELETE_RE_ORG_STORE_SUCCESS'
	},
	Restore: {
		REQUEST : 'RESTORE_RE_ORG_STORE_REQUEST',
		SUCCESS : 'RESTORE_RE_ORG_STORE_SUCCESS',
		FAILURE : 'RESTORE_RE_ORG_STORE_FAILURE'
	},
	Update: {
		SUCCESS : 'UPDATE_RE_ORG_STORE_INFO_SUCCESS',
		REQUEST : 'UPDATE_RE_ORG_STORE_INFO_REQUEST',
		FAILURE : 'UPDATE_RE_ORG_STORE_INFO_FAILURE'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_RE_ORG_STORES_SUCCESS',
		REQUEST : 'GET_PAGED_RE_ORG_STORES_REQUEST',
		FAILURE : 'GET_PAGED_RE_ORG_STORES_FAILURE'
	},
	CLEAR: 'CLEAR_RE_ORG_STORE'
}